module.exports = __webpack_public_path__ + "img/TS-Symbol-wh.c7a7c702.svg";